import { render, staticRenderFns } from "./ClosureCustom.vue?vue&type=template&id=6bab3a5f"
import script from "./ClosureCustom.vue?vue&type=script&lang=js"
export * from "./ClosureCustom.vue?vue&type=script&lang=js"
import style0 from "./ClosureCustom.vue?vue&type=style&index=0&id=6bab3a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports